import moment from 'moment';
import { encodeQueryParams } from './query-params';

// returns the path to the group rota for a specific group ID, a start time and
// end time
export const groupSchedulePath = (groupId, startTime, endTime) => {
  const queryParams = {
    start_time: moment(startTime).toISOString(),
    end_time: moment(endTime).toISOString(),
    dutify: false
  };
  const params = encodeQueryParams(queryParams);
  return `/groups/${groupId}/schedule/group_schedule?${params}`;
};
